import styled from 'styled-components';

import { device } from '../theme/devices';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 25px;
  margin: 4px 28px;
  background: rgba(196, 196, 196, 0.1);

  @media ${device.mobile} {
    padding: 10px;
    margin: 4px 0px;
    height: auto;
    justify-content: center;
  }
`;

export const IconSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  width: 375px;

  @media ${device.mobile} {
    width: auto;
  }

  strong {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin: 22px 0;
  }
`;

export const TextSection = styled.div`
  flex: 1;
  padding: 0px 16px;
  height: auto;
  p {
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: justify;
    height: auto;
  }
  ul {
    margin-left: 38px;
    height: auto;
  }
`;
